import { render, staticRenderFns } from "./CreditRuleUpsert.vue?vue&type=template&id=5b186c64"
import script from "./CreditRuleUpsert.vue?vue&type=script&lang=ts"
export * from "./CreditRuleUpsert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports